import React from 'react'
import ProductsPage from '../ProductsPage/ProductsPage'

const Products = () => {
    return (
        <div>
            <ProductsPage imageSource="images/img-9.jpg" />
        </div>
    )
}

export default Products
